import {mutations} from './mutations';
import {actions} from './actions';
import {getters} from './getters';

const state = {

    filterByGroupModel: null,
    searchTermModel: '',
    typeFilterModel: null,
    tableOptions: {
        itemsPerPage: 25,
        sortBy: ['name'],
        sortDesc: [false],
        mustSort: true,
    },
    groups: [],
    groupsLoading: false,
    groupsLoaded: false,
    groupsExpire: null,
    standardVariables: []
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

